import React, { Component } from 'react';
import ToggleSwitch from '../components/ToggleSwitch';
import { SUPPORTED_LANGUAGES } from '../../utils';

const LANGUAGE_TRANSLATION_KEYS = {
  en: 'profileForm.languageEnglish',
  no: 'profileForm.languageNorwegian',
  de: 'profileForm.languageGerman',
  fr: 'profileForm.languageFrench',
  es: 'profileForm.languageSpanish',
  ro: 'profileForm.languageRomanian',
};

class ProfileFormColumn extends Component {
  render() {
    const {
      email,
      role,
      name,
      bio,
      phone_number,
      theme,
      language,
      emailMarketing,
      error,
      t,
      onFieldChange,
    } = this.props;

    const tr = t || ((key) => key);

    return (
      <section className="pf-grid__col pf-grid__col--profile">
        <div className="pf-row pf-row--compact">
          <label htmlFor="email" className="pf-label">{tr('profileForm.email')}</label>
          <input
            id="email"
            name="email"
            type="email"
            className="pf-input"
            value={email}
            readOnly
          />
        </div>

        <div className="pf-row pf-row--compact">
          <label htmlFor="role-view" className="pf-label">{tr('profileForm.role')}</label>
          <input
            id="role-view"
            name="role-view"
            className="pf-input"
            value={String(role || 'user').toUpperCase()}
            readOnly
          />
        </div>

        <div className="pf-row pf-row--compact">
          <label htmlFor="name" className="pf-label">{tr('profileForm.name')}</label>
          <input
            id="name"
            name="name"
            className="pf-input"
            placeholder={tr('profileForm.namePlaceholder')}
            value={name}
            onChange={onFieldChange}
          />
        </div>

        <div className="pf-row pf-row--compact">
          <label htmlFor="bio" className="pf-label">{tr('profileForm.authorBio')}</label>
          <textarea
            id="bio"
            name="bio"
            className="pf-input"
            placeholder={tr('profileForm.authorBioPlaceholder')}
            value={bio}
            onChange={onFieldChange}
            rows={4}
          />
        </div>

        <div className="pf-row pf-row--compact">
          <label htmlFor="phone_number" className="pf-label">{tr('profileForm.phoneNumber')}</label>
          <input
            id="phone_number"
            name="phone_number"
            className="pf-input"
            placeholder="+47 123 45 678"
            value={phone_number}
            onChange={onFieldChange}
          />
        </div>

        
        
        <div className="pf-row">
          <label htmlFor="theme" className="pf-label">{tr('profileForm.theme')}</label>
          <select
            id="theme"
            name="theme"
            className="pf-input"
            value={theme}
            onChange={onFieldChange}
          >
            <option value="system">{tr('profileForm.themeSystem')}</option>
            <option value="light">{tr('profileForm.themeLight')}</option>
            <option value="dark">{tr('profileForm.themeDark')}</option>
          </select>
        </div>

        <div className="pf-row">
          <label htmlFor="language" className="pf-label">{tr('profileForm.language')}</label>
          <select
            id="language"
            name="language"
            className="pf-input"
            value={language}
            onChange={onFieldChange}
          >
            {SUPPORTED_LANGUAGES.map((item) => (
              <option key={item.code} value={item.code}>
                {tr(LANGUAGE_TRANSLATION_KEYS[item.code] || item.label)}
              </option>
            ))}
          </select>
        </div>

        <div className="pf-row pf-checkbox">
          <ToggleSwitch
            id="emailMarketing"
            name="emailMarketing"
            checked={emailMarketing}
            onChange={onFieldChange}
            label={tr('profileForm.emailMarketing')}
          />
        </div>

        {error && <div className="pf-error">{error}</div>}
      </section>
    );
  }
}

export default ProfileFormColumn;
